import { useRef } from "react";

import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import NewTextBlock from "../NewTextBlock/NewTextBlock";
import NewButton from "../NewButton/NewButton";

import styles from "./AboutNewComponent.module.css";

gsap.registerPlugin(ScrollTrigger);

const AboutNewComponent = ({ setIsOpenModal }) => {
  const container = useRef(null);
  const imagesRef = useRef([]);

  let mm = gsap.matchMedia();

  useGSAP(() => {

    mm.add("(min-width: 1025px)", () => {

      const tlImages = gsap.timeline({
        scrollTrigger: {
          trigger: ".aboutNew",
          start: "top 50%",
          // end: "+=50%",
          scrub: 1,
        },
      });

      tlImages
        .to("#aboutSection", {
          duration: 1,
          opacity: 1,
          // y: 0,
        })
      // .fromTo("#aboutSection #first", { y: 60 }, { y: 0 }, "<")
      // .fromTo("#aboutSection #second img", { y: 60 }, { y: 0 }, "<");

    });

    mm.add("(max-width: 1024px)", () => {
      const tlImages = gsap.timeline({
        scrollTrigger: {
          trigger: ".aboutNew",
          start: "top 80%",
          // end: "+=50%",
          scrub: 1,
        },
      });

      tlImages
        .to("#aboutSection", {
          duration: 1,
          opacity: 1,
          y: 0,
        })
      // .fromTo("#aboutSection #first", { y: 60 }, { y: 0 }, "<")
      // .fromTo("#aboutSection #second img", { y: 60 }, { y: 0 }, "<");
    });

  }, [])

  return <>
    <div className={`aboutNew ${styles.aboutNew}`} id="about">
      <div className={styles.aboutNewWrapper} >
        <div className={styles.aboutNewFirstBlock}>
          <div className={styles.aboutNewLogo}>
            <img
              id="home_name"
              src="/images/CTL_HEADING_eur.png"
              alt="CTL EUROPE Mining Supplier"
              className={styles.aboutNewCtlLogo}
            ></img>
          </div>
          <p className={styles.aboutNewText}>
            <b>CTL Europe – Where Service Meets Excellence</b>
            <br /><br />At CTL Europe, we are redefining the standard in mining and industrial supply. Based in Kent in the UK, we deliver tailored, innovative solutions that empower mining and industrial operations to perform at their best.
            <br /><br />As our client base and supplier network continue to expand, we partner exclusively with businesses that share our commitment to quality, reliability, and outstanding customer care. Every supplier is carefully selected to align with our core values, ensuring we consistently deliver superior service and products.
            <br /><br />Innovation and continuous improvement are at the core of everything we do. Whether through our paperless ordering system, comprehensive PPE and glove matrix, or our streamlined digital platform, we are committed to making processes simpler, improving safety, and equipping businesses with the tools they need to succeed.
            <br /><br />At CTL Europe, we don’t just respond to industry demands — we anticipate them. Our mission is to deliver intelligent, data-driven industrial supply solutions that optimize efficiency, reduce downtime, and empower informed decision-making. By leveraging analytics, technology, and industry expertise, we provide our clients with the insights and tools needed to enhance performance, sustainability, and long-term success.
            <br /><br />We are dedicated to evolving alongside your business, forging partnerships that support growth and success well into the future.


          </p>
        </div >
        <div className={styles.aboutNewRight} id="aboutSection">
          <div id="first" className={styles.aboutFirstSectionWrapper}>
            <div className={styles.aboutNewFirstImg}><img src="/images/wall/wall-1.jpg"></img></div>
            <div className={styles.aboutNewSecondBlock}>
              <NewTextBlock sign={"+"} title={""} number={200} subtitle="categories" description="available for order" />

              <img src="/images/wall/wall-2.jpg" className={styles.aboutNewSecondImg}></img>
            </div>
          </div>
          {/* <div  className={styles.aboutNewThirdBlock} id="second">
              <NewTextBlock sign={"+"} title={"k"} number={400} subtitle="parts" description="available for order" />   
              <div><img src="/images/about_3.png" className={styles.aboutNewSecondImg} ></img></div>
              </div> */}
        </div>
      </div >
    </div >
  </>
}

export default AboutNewComponent;
